import { render, staticRenderFns } from "./healthPad.vue?vue&type=template&id=70006961&scoped=true"
import script from "./healthPad.vue?vue&type=script&lang=js"
export * from "./healthPad.vue?vue&type=script&lang=js"
import style0 from "./healthPad.vue?vue&type=style&index=0&id=70006961&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70006961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70006961')) {
      api.createRecord('70006961', component.options)
    } else {
      api.reload('70006961', component.options)
    }
    module.hot.accept("./healthPad.vue?vue&type=template&id=70006961&scoped=true", function () {
      api.rerender('70006961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/healthPad.vue"
export default component.exports